import React, { useEffect, useRef, useState } from 'react';
import Store from '../../store/Store';
import { IconProfile, IconLogout } from '../Icons';

export interface UserMenuProps {
    props?: unknown;
}

export const UserMenu: React.FC<UserMenuProps> = (props) => {
    const [isOpen, setIsOpen] = useState(false);
    const menuRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const closeOnOutsideClick = (event: MouseEvent) => {
            if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
                setIsOpen(false);
            }
        };

        document.addEventListener('mousedown', closeOnOutsideClick);

        return () => {
            document.removeEventListener('mousedown', closeOnOutsideClick);
        };
    }, []);

    if (!Store.user) return null;

    return (
        <div className="user-menu" ref={menuRef}>
            {/* <p className="user-name">
                {Store.user.firstName} {Store.user.lastName} ({Store.getRoleLabel()})
            </p> */}
            <button
                aria-label='Menu'
                type="button"
                className="user-menu-button"
                data-pw="button-user-menu"
                onClick={() => setIsOpen((open) => !open)}
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56" fill="none">
                    <path d="M28 0.5C43.1878 0.5 55.5 12.8122 55.5 28C55.5 43.1878 43.1878 55.5 28 55.5C12.8122 55.5 0.5 43.1878 0.5 28C0.5 12.8122 12.8122 0.5 28 0.5Z" fill="white" />
                    <path d="M28 0.5C43.1878 0.5 55.5 12.8122 55.5 28C55.5 43.1878 43.1878 55.5 28 55.5C12.8122 55.5 0.5 43.1878 0.5 28C0.5 12.8122 12.8122 0.5 28 0.5Z" stroke="#E1320F" />
                    <path fillRule="evenodd" clipRule="evenodd" d="M28 20C25.7909 20 24 21.7909 24 24C24 26.2091 25.7909 28 28 28C30.2091 28 32 26.2091 32 24C32 21.7909 30.2091 20 28 20ZM22 24C22 20.6863 24.6863 18 28 18C31.3137 18 34 20.6863 34 24C34 27.3137 31.3137 30 28 30C24.6863 30 22 27.3137 22 24Z" fill="#E1320F" />
                    <path fillRule="evenodd" clipRule="evenodd" d="M21.636 30.636C23.3239 28.9482 25.6131 28 28 28C30.3869 28 32.6761 28.9482 34.364 30.636C36.0518 32.3239 37 34.6131 37 37C37 37.5523 36.5523 38 36 38C35.4477 38 35 37.5523 35 37C35 35.1435 34.2625 33.363 32.9497 32.0503C31.637 30.7375 29.8565 30 28 30C26.1435 30 24.363 30.7375 23.0503 32.0503C21.7375 33.363 21 35.1435 21 37C21 37.5523 20.5523 38 20 38C19.4477 38 19 37.5523 19 37C19 34.6131 19.9482 32.3239 21.636 30.636Z" fill="#E1320F" />
                </svg>
            </button>
            <ul className={isOpen ? 'open' : ''}>
                <li>
                    <button
                        data-pw="button-user-menu-profile"
                        onClick={() => {
                            setIsOpen(false);
                            Store.navigate('profile');
                        }} className="user-menu-item flex gap-2">
                        <IconProfile />
                        Profil
                    </button>
                </li>
                {Store.isSuperAdmin() && (
                    <li>
                        <button
                            data-pw="button-user-menu-administration"
                            onClick={() => {
                                setIsOpen(false);
                                Store.navigate('emergency');
                            }} className="user-menu-item flex gap-2">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                                stroke="#E1320F" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                                <path d="M12 3l7 3v5c0 4.5-3 8.5-7 10-4-1.5-7-5.5-7-10V6l7-3z" />
                                <path d="M9 12l2 2 4-4" />
                            </svg>
                            Administration
                        </button>
                    </li>
                )}
                <li><button
                    data-pw="button-user-menu-logout"
                    onClick={() => {
                        setIsOpen(false);
                        Store.onLogout();
                    }} className="user-menu-item flex gap-2">
                    <IconLogout />
                    Logout
                </button></li>
            </ul>
        </div>
    );
};
